<template>
  <v-app-bar class="vt-app-bar" v-if="$auth.isAuthenticated" app flat>
    <span @click.stop="$store.commit('toggle_nav_bar')" class="backgroundWhite rounded px-3 pt-2 pb-3 mr-2">
      <v-icon small color="primaryGrey">menu</v-icon>
    </span>

    <v-toolbar-title class="toolbar-title">
      <span class="title titleLight--text">{{ $store.state.page_title }}</span>
      <v-chip small v-if="!isProd" class="mx-2 mb-1 font-weight-bold" color="primaryOutline" label dark>
        {{ `${current_env.substring(0, 3)}` }}
      </v-chip>
    </v-toolbar-title>

    <v-spacer></v-spacer>

    <div class="d-flex pt-7">
      <v-text-field
        v-model="$store.state.search_key"
        :placeholder="search_placeholder"
        class="search-bar remove-bottom-border pr-2"
        height="2rem"
        append-icon="mdi-magnify"
        single-line
        solo
        dense
      />

      <ThemeVT />

      <LanguageSelect v-if="$store.state.showLanguage" class="pl-2" style="max-width: 75px" :colLenght="1" />
    </div>
  </v-app-bar>
</template>

<script>
import LanguageSelect from "./LanguageSelect.vue";
import ThemeVT from "./ThemeVT.vue";

export default {
  name: "PageHeader",
  components: { LanguageSelect, ThemeVT },
  data() {
    return {
      search_placeholder: this.$t("common.words.search"),
      searchClosed: false,
    };
  },
  methods: {
    open_section(s) {
      this.$store.commit("update_page_name", s);
    },
    login() {
      this.$auth.loginWithRedirect({ appState: { targetUrl: "/" } });
    },
  },

  computed: {
    currentRouteName() {
      return this.$route.name;
    },
    current_env() {
      return process.env["NODE_ENV"];
    },
    isProd() {
      return this.current_env.toLowerCase().includes("production");
    },
  },
};
</script>

<style lang="sass">
.vt-app-bar
  background-color: var(--v-backgroundLight-base) !important

.search-bar
  width: 600px
  max-width: 820px

.toolbar-title
  min-width: 50px !important
</style>
